module.exports = __webpack_public_path__ + "assets/img/ds-popup-bg.a01bf43a.png";